module.exports = __webpack_public_path__ + "static/img/lybbanner.843254d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/itemimage/lybbanner.png
// module id = HAGK
// module chunks = 1